module.exports = {
  "CS_FE_Select_Product_VbhT": "Selecione “PM and DEV Role”",
  "CS_status_Dibi_hJVY": "Continuar ({{time_second}})",
  "CS_system_Submission_cEep": "Enviar",
  "CS_1_WiFi_pyYD": "Wi-Fi",
  "CS_FE_You_can_yIrn": "Selecione abaixo o tipo de permissão que você precisa e clique em Aplicar.",
  "CS_status_SYOk_iYUs": "B2B",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_See_permissions_OzjQ": "Para mais informações, consulte as Diretrizes de Acesso ao Sistema do Atendimento ao Cliente",
  "CS_status_ZoGi_sjyC": "Central do motorista",
  "CS_1_Environment_Bitb": "Ambiente",
  "CS_1_View_Current_IOCz": "Ver permissões atuais",
  "CS_optimazation__CALn": "Seu status foi alterado automaticamente para off-line devido à inatividade. Atualize a página.",
  "CS_1_Upgrade_current_dlbi": "Elevar permissões atuais",
  "CS_optimazation_You_have_PlRk": "Não detectamos nenhuma atividade no {{workbench_name}} por {{time_duration}} minuto(s). Quer continuar trabalhando no {{workbench_name}}?",
  "CS_optimazation__akmu": "Desconectado(a)",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Customer_service_oPui": "Se você não for um(a) Analista de Atendimento ao Cliente:",
  "CS_status_ixVR_bjQc": "Vendas",
  "CS_feedback_Feedback_bGXI": "Comentários",
  "CS_optimazation__ZkZb": "Continuar {{work_status}}",
  "CS_System_ZQjn_eCbz": "Tipo de competência treinado anteriormente",
  "CS_status_CjDQ_uaVo": "Antifraude",
  "CS_Status_In_the_PrHj": "Outras pausas em andamento",
  "CS_1_Thank_you_WUlL": "Agradecemos seus comentários!",
  "CS_status_ErSl_RYFT": "Ligar",
  "CS_1_Log_in_sMmF": "Sair",
  "CS_status_HxNd_EpND": "Câmera de segurança",
  "CS_status_HMDn_eBqC": "Engajamento",
  "CS_status_zoxI_Nral": "O tipo de serviço atual é {{service_type}}",
  "CS_feedback_1_Please_IBbL": "1. Nos conte com o qual recurso você está tendo problemas e descreva o que aconteceu",
  "CS_1_Closing_Online_tykf": "Desativar chat ao vivo",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Permission_Kapv": "Selecione sua permissão de acesso",
  "CS_1_Open_automatic_PZyZ": "Ativar atribuição automática de ticket",
  "CS_FE_Ark_Visitor_pMCT": "CRM View Permission",
  "CS_1_Enter_text_NYGo": "Escreva seu comentário aqui",
  "CS_status_WEAx_MWhv": "Segurança",
  "CS_System_lIGK_Ukwr": "Tipo de competências atuais",
  "CS_optimazation_Telephone_workstations_TBZP": "Area de trabalho para chamadas",
  "CS_system_Name_of_QEFT": "Nome do cargo",
  "CS_status_dweh_wRWT": "Análise de associação",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Sorry_permissions_nBRG": "Você não tem permissão para acessar o sistema. Para solicitar a permissão, siga as instruções abaixo.",
  "CS_optimazation__work_JhhB": "Seu status de trabalho é {{work_status}} por mais de {{time_duration}} minutos. Quer continuar {{work_status}}?",
  "CS_Workbench_Online_Customer_yXxN": "Área de trabalho do chat ao vivo",
  "CS_status_wfIq_oGhU": "Redes sociais",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Production_and_mGLI": "Selecione o tipo de permissão necessária abaixo, depois clique em Apply.\n\nSe você estiver na equipe de desenvolvimento e produto do atendimento ao cliente: selecione \"PM and DEV Role\"\n\nPara outras funções (produto e desenvolvimento IBT, operações ou equipe local): selecione \"CRM View Permission (Role ID: 14211591)\"",
  "CS_optimazation_Time_out_sqTe": "Lembrete de tempo limite",
  "CS_1_Country_ilYw": "País",
  "CS_1_Closed_automatic_jUvk": "Desativar atribuição automática de ticket",
  "CS_1_System_Category_rAJC": "Categoria do negócio",
  "CS_status_aobY_gRor": "Seu status de trabalho é {{status_name}} por mais de {{hour_time}} hora(s). Quer continuar {{status_name}}?",
  "CS_FE_If_you_lCHy": "Se você faz parte da equipe de produto e desenvolvimento do Atendimento ao Cliente:",
  "CS_status_qORz_iUKj": "Cobrança",
  "CS_optimazation_The_status_hqOj": "Não é possível alterar o status. Acesse a Genesys.",
  "CS_optimazation_After_the_dZsk": "Processamento após a chamada",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Customer_service_vLUC": "Se você for Analista de Atendimento ao Cliente:",
  "CS_feedback_Please_upload_zHqW": "2. Para nos ajudar a entender o problema, faça upload de uma imagem e certifique-se de que não esteja cortada",
  "CS_system_Sectoral_information_JizK": "Informações do departamento",
  "CS_optimazation__zXnN": "Tempo limite de {{work_status}}",
  "CS_status_eJtD_Xawt": "Suporte técnico",
  "CS_1_Personal_settings_eXQD": "Configurações pessoais",
  "CS_optimazation_Asynchronous_workstations_JwBF": "Area de trabalho mensagens escrita",
  "CS_status_YyJG_Khkr": "Linha de frente do Atendimento ao Cliente",
  "CS_FE_Product_R_RxVt": "PM and DEV Role",
  "CS_1_Online_Customer_SvgB": "O chat ao vivo está ativado",
  "CS_status_pySZ_YnQN": "Análise de conteúdo",
  "CS_1_Open_Online_umkV": "Ativar chat ao vivo",
  "CS_1_Languages_hMbf": "Idioma",
  "CS_system_Immediate_superior_VDep": "Supervisor",
  "CS_1_Personal_settings_uOXW": "Configurações pessoais",
  "CS_FE_Choose_Ark_VJpl": "Selecione “CRM View Permission” (ID da função: 14211591)",
  "CS_1_Permissions_MuvF": "Permissões",
  "CS_FE_If_you_WAuP": "Se a sua função é outra (como de produto e desenvolvimento IBT, operações, ou caso você seja um colaborador residente na China):",
  "CS_status_ocdu_QQQW": "Chamada de vídeo",
  "CS_1_Automatic_Order_Mnnv": "A atribuição automática de ticket está ativada",
  "CS_optimazation_Make_sure_FVAQ": "Tem certeza de que deseja trocar o status da {{workbench_name}} de {{status_one}} para {{status_two}}? Depois de trocar, os status das outras áreas de trabalho serão definidos como {{status_three}}.",
  "CS_1_Comments_RcMN": "Enviar",
  "CS_1_Notification_uJTM": "Notificações",
  "CS_Tools_Ark_System_Quick_Access_for_Permission_Application_Hello_permissions_SDxI": "Entre em contato com seu supervisor ou com o administrador local responsável pelas permissões de atendimento ao cliente para obter ajuda.",
  "status_400": "Pausa para refeição...",
  "refreshPage": "Atualize a página",
  "countDownBegin": "Operation after ",
  "infoChange": "A categoria do sistema foi alterada em outra página. Suas alterações não serão salvas. Atualize a página.",
  "view": "Ver",
  "online": "Ambiente on-line",
  "message": "Mensagens",
  "changeStatusV1": "Tem certeza de que deseja alterar seu status de trabalho de ",
  "changeStatusV2": " para ",
  "changeStatusV3": "？",
  "time": "Data",
  "continue": "Continuar",
  "knowledge": "Banco de dados",
  "status_500": "Pausa para intervalo...",
  "artificial": "Mensagem direta",
  "countDownEnd": "S",
  "clickStartWorking": "Para garantir a precisão dos dados, toque em Começar antes de usar o sistema",
  "statusChange": "Para aceitar os tickets automaticamente, defina seu status de trabalho como “Disponível”.",
  "CS_Workbench_There_are_wmir": "Não foi possível alterar o status de trabalho. Primeiro, conclua todos os chats ao vivo em andamento.",
  "type": "Tipo de mensagem",
  "status_200": "Treinamento em andamento...",
  "cancel": "Cancelar",
  "logout": "Sair",
  "sendTo": "Para",
  "satisfaction_content": "Você possui uma pesquisa para ser respondida, ela deve durar cerca de 5 minutos. Caso queira responder agora, clique no link abaixo ou no botão de \"Continuar\"",
  "CS_Workbench_Open_the_lnHa": "Ao usar o workbench do chat ao vivo, certifique-se de que seu status de trabalho esteja definido como “Disponível”.",
  "ticketNumber": " ticket(s) pendente(s)",
  "more": "More",
  "satisfaction_title": "Você possui uma pesquisa",
  "pre": "Ambiente pré-evento",
  "customerService": "Central de atendimento",
  "status_300": "Reunião em andamento...",
  "sendFrom": "De",
  "youhave": "Você tem ",
  "startWorking": "Começar",
  "small": "Ambiente de aceitação",
  "offWorkV": "Tem certeza de que deseja se desconectar? Isso vai indicar o término do dia",
  "read": "Have read",
  "Settings": "Configurações",
  "welcomeCS": "Bem-vindo ao Sistema Global de Atendimento ao Cliente da 99",
  "cs-micro-front-end---more": "",
  "cs-micro-front-end---welcomeCS": "",
  "cs-micro-front-end---clickStartWorking": "",
  "cs-micro-front-end---startWorking": "",
  "cs-micro-front-end---status_200": "",
  "cs-micro-front-end---status_300": "",
  "cs-micro-front-end---status_400": "",
  "cs-micro-front-end---status_500": "",
  "cs-micro-front-end---offWorkV": "",
  "cs-micro-front-end---changeStatusV1": "",
  "cs-micro-front-end---changeStatusV2": "",
  "cs-micro-front-end---changeStatusV3": "",
  "cs-micro-front-end---cancel": "",
  "cs-micro-front-end---continue": "",
  "cs-micro-front-end---logout": "",
  "cs-micro-front-end---online": "",
  "cs-micro-front-end---pre": "",
  "cs-micro-front-end---small": "",
  "cs-micro-front-end---statusChange": "",
  "cs-micro-front-end---youhave": "",
  "cs-micro-front-end---ticketNumber": "",
  "cs-micro-front-end---view": "",
  "cs-micro-front-end---Settings": "",
  "cs-micro-front-end---infoChange": "",
  "cs-micro-front-end---refreshPage": "",
  "cs-micro-front-end---satisfaction_title": "",
  "cs-micro-front-end---satisfaction_content": "",
  "cs-micro-front-end---knowledge": "",
  "cs-micro-front-end---customerService": "",
  "cs-micro-front-end---artificial": "",
  "cs-micro-front-end---sendFrom": "",
  "cs-micro-front-end---sendTo": "",
  "cs-micro-front-end---type": "",
  "cs-micro-front-end---time": "",
  "cs-micro-front-end---read": "",
  "cs-micro-front-end---countDownBegin": "",
  "cs-micro-front-end---countDownEnd": "",
  "cs-micro-front-end---CS_Workbench_There_are_wmir": "",
  "cs-micro-front-end---CS_Workbench_Open_the_lnHa": "",
  "cs-micro-front-end---message": ""
}